module.exports = __webpack_public_path__ + "img/13926246baf7c6b88c6fed2a3c150ea5.png";